import { BaseStore } from "../../../../react-core/Flux/BaseStore";
import { ClosingAccountDispatcher } from "./Variable";
import { ActionType } from "../../../../react-core/Flux/ActionType";

export interface ClosingAccountStoreStaticState {
    isLoading?: boolean;
    actionType: ActionType;
    data?: any;
}

export class ClosingAccountStoreStatic extends BaseStore<ClosingAccountStoreStaticState> {
    constructor() {
        super();
        this.subscribeToDispatcher(ClosingAccountDispatcher, (actionData) =>
            this.onClosingAccountStoreResponse(actionData)
        );
    }

    public getLastResult(): ClosingAccountStoreStaticState {
        return this.getState();
    }

    public isLoading(): boolean {
        return this.getState().isLoading;
    }

    public getData() {
        return this.getState().data;
    }

    public getActionType() {
        return this.getState().actionType;
    }

    protected getDefaultState(): ClosingAccountStoreStaticState {
        return {
            actionType: ActionType.Loading,
            data: null,
            isLoading: false,
        };
    }

    private onClosingAccountStoreResponse(actionData): void {
        switch (actionData.actionType) {
            case ActionType.Success:
                this.setState({ actionType: ActionType.Success, data: actionData.payload });
                break;
            case ActionType.Error:
                this.setState({ actionType: ActionType.Error });
                break;
            case ActionType.Loading:
                this.setState({ isLoading: actionData.payload, actionType: ActionType.Loading });
                break;
        }
    }
}
